import { render, staticRenderFns } from "./orderItem.vue?vue&type=template&id=71e226a1&"
import script from "./orderItem.vue?vue&type=script&lang=js&"
export * from "./orderItem.vue?vue&type=script&lang=js&"
import style0 from "./orderItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports